import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomLoadingPriceStateType {
    /** Map of productId to loading state */
    readonly loadingByProductId: Record<string, boolean>;
}

export type CustomLoadingPriceState = Readonly<CustomLoadingPriceStateType>;

export const initialCustomLoadingPriceState: CustomLoadingPriceState = {
    loadingByProductId: {},
};

export const customLoadingPriceReducer = createTypedReducer(initialCustomLoadingPriceState, {
    "Custom/LoadingPrice/BeginLoadingPrice": (
        draft: Draft<CustomLoadingPriceState>,
        action: { productId: string },
    ) => ({
        ...draft,
        loadingByProductId: {
            ...draft.loadingByProductId,
            [action.productId]: true,
        },
    }),
    "Custom/LoadingPrice/CompleteLoadingPrice": (
        draft: Draft<CustomLoadingPriceState>,
        action: { productId: string },
    ) => ({
        ...draft,
        loadingByProductId: {
            ...draft.loadingByProductId,
            [action.productId]: false,
        },
    }),
});
